function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.2995 4.15148H19.0526C17.1325 1.69947 14.1471 0.121582 10.791 0.121582C10.8536 0.121582 10.9144 0.124031 10.9734 0.128876C10.9133 0.124205 10.8525 0.121845 10.7911 0.121845C10.5824 0.121845 10.375 0.127957 10.169 0.140225C10.168 0.140225 10.167 0.140302 10.1661 0.14038C10.1651 0.140457 10.1642 0.140535 10.1632 0.140535C7.06453 0.323581 4.32911 1.85377 2.52996 4.15174H14.2995C14.2995 4.15166 14.2995 4.15157 14.2995 4.15148ZM19.0524 17.0702C17.1379 19.5156 14.164 21.0912 10.8193 21.1C10.8132 21.1001 10.807 21.1001 10.8008 21.1002C10.7976 21.1002 10.7943 21.1002 10.791 21.1002C10.5823 21.1002 10.3749 21.094 10.1689 21.0821C10.1679 21.0821 10.1669 21.082 10.166 21.082L10.1659 21.082C10.165 21.0819 10.1641 21.0818 10.1631 21.0818C7.06448 20.8986 4.32906 19.3686 2.52991 17.0703H13.5279L13.5279 17.0702H19.0524ZM10.1661 0.140182C10.1651 0.14026 10.1642 0.140337 10.1632 0.140337C10.1651 0.139983 10.1671 0.139983 10.169 0.140027C10.168 0.140027 10.167 0.140105 10.1661 0.140182Z",
  fill: "#D32030"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.5278 4.15234H19.0526C20.4467 5.93329 21.2803 8.17449 21.2802 10.6118C21.2802 13.0492 20.4466 15.2902 19.0521 17.071H14.2994C14.2994 17.071 14.2994 17.0711 14.2994 17.0711H2.52979C1.13526 15.2904 0.301697 13.0494 0.301697 10.6119C0.301697 8.17464 1.13526 5.93344 2.52979 4.15249H13.5278C13.5278 4.15244 13.5278 4.15239 13.5278 4.15234Z",
  fill: "#FFD034"
});

var SvgESflag = function SvgESflag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgESflag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ESflag.581fed7f.svg";
export { ForwardRef as ReactComponent };